import { CommonModule, CurrencyPipe, DecimalPipe, TitleCasePipe } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, Routes } from '@angular/router';
import { EffectsModule } from '@ngrx/effects';
import { OptInUiModule } from '../shared/components/opt-in/opt-in.module';
import { StoreModule } from '@ngrx/store';
import { MaterialModule } from '../../../assets/material/material.module';
import { AuthGuard } from '../../guards/auth.guard';
import { SamlGuard } from '../../guards/saml.guard';
import { AccountsModule } from '../accounts/accounts.module';
import { AccountsEffects } from '../accounts/store/accounts.effects';
import { CreditHealthModule } from '../credit-health/credit-health.module';
import { CreditHealthEffect } from '../credit-health/store/credit-health.effect';
import { creditHealthReducer } from '../credit-health/store/credit-health.reducer';
import { CustomerAttributesEffect } from '../customer-attributes/store/customer-attributes.effects';
import { customerAttributesReducer } from '../customer-attributes/store/customer-attributes.reducer';
import { OffersEffects } from '../offers/store/effects/offers.effects';
import { ProfileModule, profileRoutes } from '../profile/profile.module';
import { SharedModule } from '../shared/shared.module';
import { CarouselItemComponent } from './components/carousel-item/carousel-item.component';
import { FinancialInsightHeroComponent } from './components/financial-insight-hero/financial-insight-hero.component';
import { SecurityModalComponent } from './components/security-modal/security-modal.component';
import { CarouselComponent } from './containers/carousel/carousel.component';

// Replace CustomerHubSplitComponent with CustomerHubV2Component when AWEE345HubUIUpdate flag is removed
// import { CustomerHubComponent } from './containers/customer-hub/customer-hub.component';
// import { CustomerHubV2Component } from './containers/customer-hub-v2/customer-hub-v2.component';
import { AccountsNotificationsModule } from '../accounts-notifications/accounts-notifications.module';
import { accountsReducer } from '../accounts/store/accounts.reducer';
import { HslSlideOutComponent } from '../offers/containers/hsl-slide-out/hsl-slide-out.component';
import { offersFeatureKey, offersReducer } from '../offers/store/reducers/offers.reducers';
import { OptInNgrxModule } from '../opt-in/opt-in.module';
import { Saml2Component } from '../redirect/containers/saml2/saml2.component';
import { HubCardVerificationModalComponent } from '../shared/components/hub-card-verification-modal/hub-card-verification-modal.component';
import { IconCloseComponent } from '../shared/components/icon-close/icon-close.component';
import { AccountCardComponent } from './components/account-card/account-card.component';
import { DebtConsolidationPlacementComponent } from './components/debt-consolidation-placement/debt-consolidation-placement.component';
import { DollarParserComponent } from './components/dollar-parser/dollar-parser.component';
import { EmptyAccountCardComponent } from './components/empty-account-card/empty-account-card.component';
import { LineChartComponent } from './components/line-chart/line-chart.component';
import { MobileAppCardComponent } from './components/mobile-app-card/mobile-app-card.component';
import { NotificationBannerComponent } from './components/notification-banner/notification-banner.component';
import { OfferDetailsComponent } from './components/offer-details/offer-details.component';
import { OffersCarouselComponent } from './components/offers-carousel/offers-carousel.component';
import { VantageScoreCardComponent } from './components/vantage-score-card/vantage-score-card.component';
import { WelcomeModalComponent } from './components/welcome-modal/welcome-modal.component';
import { CustomerHubV2Component } from './containers/customer-hub-v2/customer-hub-v2.component';
import { OffersDisclosureComponent } from '../offers/components/offers-disclosure/offers-disclosure.component';
import { ServiceAlertBannerComponent } from '../shared/components/service-alert-banner/service-alert-banner.component';

export const customerHubRoutes: Routes = [
  { path: '', component: CustomerHubV2Component },
  { path: 'saml2', component: Saml2Component, canActivate: [AuthGuard, SamlGuard] },
  {
    path: 'profile',
    children: profileRoutes,
  },
];

@NgModule({
  declarations: [
    CustomerHubV2Component,
    AccountCardComponent,
    DollarParserComponent,
    NotificationBannerComponent,
    EmptyAccountCardComponent,
    LineChartComponent,
    OfferDetailsComponent,
    VantageScoreCardComponent,
    WelcomeModalComponent,
    CarouselComponent,
    CarouselItemComponent,
    FinancialInsightHeroComponent,
    SecurityModalComponent,
    OffersCarouselComponent,
  ],
  imports: [
    OptInUiModule,
    BrowserAnimationsModule,
    CommonModule,
    MaterialModule,
    RouterModule,
    StoreModule.forFeature('accounts', accountsReducer),
    StoreModule.forFeature('cas', customerAttributesReducer),
    StoreModule.forFeature('creditHealth', creditHealthReducer),
    StoreModule.forFeature(offersFeatureKey, offersReducer),
    EffectsModule.forFeature([OffersEffects, AccountsEffects, CustomerAttributesEffect, CreditHealthEffect]),
    ProfileModule,
    AccountsModule,
    CreditHealthModule,
    SharedModule,
    OptInNgrxModule,
    AccountsNotificationsModule,
    IconCloseComponent,
    HubCardVerificationModalComponent,
    MobileAppCardComponent,
    HslSlideOutComponent,
    DebtConsolidationPlacementComponent,
    ServiceAlertBannerComponent,
    OffersDisclosureComponent
  ],
  providers: [CurrencyPipe, TitleCasePipe, DecimalPipe, provideHttpClient(withInterceptorsFromDi())],
})
export class CustomerHubModule {}
